
<mat-sidenav-container class="principal-menu principal-menu-v2">
  <mat-sidenav #sidenav mode="side" [class.rail-mode]="isRailMode" [opened]="true" id="sideNavRailV2">
    <div class="menu-header">
      <button class="toggle-menu" mat-button type="button" (click)="toggleRailMode()" [attr.aria-label]="'menu.toggle' | translate">
        <mat-icon fontSet="material-icons-outlined">{{ isRailMode ? 'menu' : 'close' }}</mat-icon>
      </button>
      <img *ngIf="isRailMode" class="logo-icon" [src]="logoRailMode" alt="munily-icon" />
      <img *ngIf="!isRailMode" class="logo" [src]="logoFullMode" alt="munily-logo" />
    </div>
    <mat-nav-list class="sidebar-main-list">
      <div *ngFor="let sidebarnavItem of sidebarnavItems">
        <div *ngIf="sidebarnavItem.extralink === true" class="nav-small-cap">
          {{ sidebarnavItem.title }}
        </div>

        <mat-list-item *ngIf="(!sidebarnavItem.submenu?.length > 0)"
          [ngClass]="{'active' : isActive(sidebarnavItem.path)}"
          [disableRipple]="isExpanded(sidebarnavItem.title)"
          role="button" tabindex="0"
          [attr.aria-label]="sidebarnavItem.title | translate"
          (keydown.enter)="handleMenuItemClick(sidebarnavItem)"
          (keydown.space)="$event.preventDefault(); handleMenuItemClick(sidebarnavItem)"
          (click)="handleMenuItemClick(sidebarnavItem)">
          <a class="sidebar-link icon-left">
            <mat-icon class="material-symbols-rounded" *ngIf="sidebarnavItem.icon && !sidebarnavItem.icon2">{{ sidebarnavItem.icon }}</mat-icon>
            <img class="material-symbols-rounded" *ngIf="sidebarnavItem.icon2" [src]="sidebarnavItem.icon2" alt="">
            <span *ngIf="!isRailMode">{{ sidebarnavItem.title | translate }}</span>
          </a>
        </mat-list-item>

        <mat-list-item
          [ngClass]="{'active' : isActive(sidebarnavItem.path)}"
          [disableRipple]="isExpanded(sidebarnavItem.title)"
          *ngIf="(sidebarnavItem.submenu?.length > 0)"
          role="button" tabindex="0"
          [attr.aria-label]="sidebarnavItem.title | translate"
          [attr.aria-expanded]="isExpanded(sidebarnavItem.title)"
          (keydown.enter)="addExpandClass(sidebarnavItem.title)"
          (keydown.space)="$event.preventDefault(); addExpandClass(sidebarnavItem.title)"
          (click)="addExpandClass(sidebarnavItem.title)">
          <div class="submenu w-100">
            <a mat-line class="sidebar-link icon-left submenu-name">
              <mat-icon class="material-symbols-rounded" *ngIf="sidebarnavItem.icon && !sidebarnavItem.icon2">{{ sidebarnavItem.icon }}</mat-icon>
              <img class="material-symbols-rounded" *ngIf="sidebarnavItem.icon2" [src]="sidebarnavItem.icon2" alt="">
              <span *ngIf="!isRailMode">{{ sidebarnavItem.title | translate }}</span>
              <mat-icon class="material-symbols-rounded ml-auto arrow-icon">
                {{ isExpanded(sidebarnavItem.title) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </a>
            <mat-nav-list *ngIf="isExpanded(sidebarnavItem.title)" class="second-level" (click)="$event.stopPropagation()">
              <mat-list-item
                *ngFor="let subItem of sidebarnavItem.submenu"
                [ngClass]="{'active' : isActive(subItem.path)}"
                role="button" tabindex="0"
                [attr.aria-label]="subItem.title | translate"
                (keydown.enter)="handleMenuItemClick(subItem)"
                (keydown.space)="$event.preventDefault(); handleMenuItemClick(subItem)"
                (click)="handleMenuItemClick(subItem)">
                <a class="sidebar-link" mat-line>
                  <span *ngIf="!isRailMode">{{ subItem.title | translate }}</span>
                  <small class="sidebar-badge" *ngIf="!isRailMode && subItem.title === menuItemTitleKeys.ticketsV2 && badgeCounts.pqrs > 0">
                    {{ badgeCounts.pqrs }}
                  </small>
                  <small class="sidebar-badge" *ngIf="!isRailMode && subItem.title === menuItemTitleKeys.chats && badgeCounts.chat > 0">
                    {{ badgeCounts.chat }}
                  </small>
                  <small class="sidebar-badge" *ngIf="!isRailMode && subItem.title === menuItemTitleKeys.reservations && badgeCounts.reservations > 0">
                    {{ badgeCounts.reservations }}
                  </small>
                  <small class="sidebar-badge" *ngIf="!isRailMode && subItem.title === menuItemTitleKeys.approveUsers && badgeCounts.preRegistrations > 0">
                    {{ badgeCounts.preRegistrations }}
                  </small>
                  <!-- ODP-21 — distintivo fijo, no un contador: marca la sección como recién lanzada. -->
                  <small class="sidebar-badge sidebar-badge--new" *ngIf="!isRailMode && subItem.title === menuItemTitleKeys.aiAssistant">
                    {{ 'menu.badges.new' | translate }}
                  </small>
                </a>
              </mat-list-item>
            </mat-nav-list>
          </div>
        </mat-list-item>
      </div>
    </mat-nav-list>

    <mat-nav-list *ngIf="bottomNavItems?.length > 0" class="sidebar-bottom-list">
      <div *ngFor="let bottomNavItem of bottomNavItems">
        <mat-list-item
          [ngClass]="{'active' : isActive(bottomNavItem.path)}"
          role="button" tabindex="0"
          [attr.aria-label]="bottomNavItem.title | translate"
          (keydown.enter)="handleMenuItemClick(bottomNavItem)"
          (keydown.space)="$event.preventDefault(); handleMenuItemClick(bottomNavItem)"
          (click)="handleMenuItemClick(bottomNavItem)">
          <a class="sidebar-link icon-left">
            <mat-icon class="material-symbols-rounded" *ngIf="bottomNavItem.icon && !bottomNavItem.icon2">{{ bottomNavItem.icon }}</mat-icon>
            <img class="material-symbols-rounded" *ngIf="bottomNavItem.icon2" [src]="bottomNavItem.icon2" alt="">
            <span *ngIf="!isRailMode">{{ bottomNavItem.title | translate }}</span>
          </a>
        </mat-list-item>
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content [ngClass]="isRailMode ? 'rail-mode' : 'drawer-mode'" id="sideNavContentV2">
    <nav class="navbar top-navbar navbar-expand-md p-0">
      <app-navigation-v2 class="w-100 navigation"></app-navigation-v2>
    </nav>
    <section class="pages-outlet-container">
      <router-outlet></router-outlet>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>
